import { MapControl } from '@leverege/ui-mapbox-elements';
const handleGroupingSelection = e => {
  const bounds = e.detail?.level?.bounds;
  if (bounds) {
    MapControl.flyToBounds('map', bounds);
  }
};
export default handleGroupingSelection;